import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SplitPaymentOnNonDomesticSaleError extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.split-payment.split-payment-on-non-domestic-sale');
    }
}
